"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dateFormat = 'DD/MM/YYYY';
exports.timeFormat = 'hh:mm';
exports.monthYearFormat = 'MM/YYYY';
